import { render, staticRenderFns } from "./errorTips.vue?vue&type=template&id=0e0729cc&scoped=true"
import script from "./errorTips.vue?vue&type=script&lang=js"
export * from "./errorTips.vue?vue&type=script&lang=js"
import style0 from "./errorTips.vue?vue&type=style&index=0&id=0e0729cc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e0729cc",
  null
  
)

export default component.exports